class MtProductComparison extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute('data-initialized')) {
      return;
    }

    this.setAttribute('data-initialized', '');
    this.toggleButton = this.querySelector('.mt-product-comparison__toggle');
    this.extraRows = Array.from(this.querySelectorAll('.mt-product-comparison__row.is-extra'));
    this.scrollArea = this.querySelector('.mt-product-comparison__scroll');
    this.scrollbarThumb = this.querySelector('.mt-product-comparison__scrollbar-thumb');

    if (this.toggleButton && this.extraRows.length > 0) {
      this.onToggle = () => this.toggleRows();
      this.toggleButton.addEventListener('click', this.onToggle);
    }

    if (this.scrollArea && this.scrollbarThumb) {
      this.onScroll = () => this.updateScrollProgress();
      this.scrollArea.addEventListener('scroll', this.onScroll, { passive: true });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.updateScrollProgress());
        this.resizeObserver.observe(this.scrollArea);
        this.resizeObserver.observe(this.scrollArea.firstElementChild);
      } else {
        this.onResize = () => this.updateScrollProgress();
        window.addEventListener('resize', this.onResize);
      }

      requestAnimationFrame(() => this.updateScrollProgress());
    }
  }

  disconnectedCallback() {
    if (this.toggleButton && this.onToggle) {
      this.toggleButton.removeEventListener('click', this.onToggle);
    }

    if (this.scrollArea && this.onScroll) {
      this.scrollArea.removeEventListener('scroll', this.onScroll);
    }

    this.resizeObserver?.disconnect();

    if (this.onResize) {
      window.removeEventListener('resize', this.onResize);
    }

    this.removeAttribute('data-initialized');
  }

  toggleRows() {
    const isExpanded = this.dataset.expanded === 'true';
    const nextExpanded = !isExpanded;
    const nextLabel = nextExpanded ? this.toggleButton.dataset.collapseLabel : this.toggleButton.dataset.expandLabel;

    this.dataset.expanded = String(nextExpanded);
    this.toggleButton.setAttribute('aria-expanded', String(nextExpanded));
    this.toggleButton.querySelector('.mt-product-comparison__toggle-label').textContent = nextLabel;

    this.extraRows.forEach((row) => {
      row.hidden = !nextExpanded;
    });

    requestAnimationFrame(() => this.updateScrollProgress());
  }

  updateScrollProgress() {
    const scrollWidth = Math.max(this.scrollArea.scrollWidth, 1);
    const visibleRatio = Math.min(1, this.scrollArea.clientWidth / scrollWidth);
    const maxScrollLeft = Math.max(0, scrollWidth - this.scrollArea.clientWidth);
    const progress = maxScrollLeft > 0 ? this.scrollArea.scrollLeft / maxScrollLeft : 0;
    const left = (1 - visibleRatio) * progress * 100;

    this.scrollbarThumb.style.width = `${visibleRatio * 100}%`;
    this.scrollbarThumb.style.left = `${left}%`;
  }
}

if (!customElements.get('mt-product-comparison')) {
  customElements.define('mt-product-comparison', MtProductComparison);
}
